import React from "react";
import { IconMessageDots } from "@tabler/icons-react";
import { twMerge } from "tailwind-merge";
import type { CallState } from "../../store/@types/chat";

type ChatFABProps = {
  callState: CallState;
  onClick: () => void;
};

const ChatFAB: React.FC<ChatFABProps> = ({ callState, onClick }) => {
  const isOnCall = callState !== "idle";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Toggle chat"
      className={twMerge(
        "fixed bottom-24 right-4 z-50 flex h-14 w-14 items-center justify-center rounded-full text-white shadow-lg transition duration-200 ease-out hover:-translate-y-1 hover:scale-105 sm:bottom-28 sm:right-10",
        isOnCall
          ? "bg-red-500 shadow-red-500/30"
          : "bg-primary-600 shadow-primary-500/30",
      )}
    >
      {isOnCall && (
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-40" />
      )}
      <IconMessageDots size={28} className="relative" />
    </button>
  );
};

export default ChatFAB;
